/**
 * Script de Carrito: Agregar Addon Fee para Pre-Orders
 * Versión 6.4 PRODUCTION - Con Safety Timeout
 * - Botón deshabilitado por defecto en HTML
 * - Selectores fallback para encontrar botón
 * - Timeout de seguridad: habilita después de 3s si no se habilitó
 * - Preserva el HTML original del botón
 * - Sin mensajes de error visibles
 */

(function() {
  'use strict';
  
  // CONFIGURACIÓN
  const CONFIG = {
    addonProductHandle: 'pre-order-addon-fee',
    addonProductId: 9185819132124,
    addonVariantA_Id: 47357588635868,
    addonVariantB_Id: 47357588668636,
    useAutoVariants: true,
    debug: false,
    checkInterval: 500,
    maxWaitForPav: 5000,
    checkoutButtonSelector: '[data-preorder-protected="true"]', // Selector primario
    checkoutButtonFallbacks: [  // Selectores de respaldo
      '[name="checkout"]',
      'button[type="submit"]',
      '.checkout-button',
      'button.button'
    ],
    safetyTimeout: 3000 // Timeout de seguridad: 3 segundos
  };
  
  // Estado
  let preorderVariants = new Set();
  let isProcessing = false;
  let lastCartState = null;
  let checkIntervalId = null;
  let pavCheckAttempts = 0;
  let checkoutEnabled = false; // Track si el checkout está habilitado
  let safetyTimeoutId = null; // NUEVO: ID del timeout de seguridad
  
  function log(message, data = null) {
    const timestamp = new Date().toLocaleTimeString('es-CO', { 
      hour12: false, 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit', 
      fractionalSecondDigits: 3 
    });
    
    if (!CONFIG.debug) {
      if (message.includes('✅') || message.includes('❌') || message.includes('⚠️') || 
          message.includes('🔒') || message.includes('🔓')) {
        //console.log(`[${timestamp}] [PreOrder Addon] ${message}`, data || '');
      }
      return;
    }
    //console.log(`[${timestamp}] [PreOrder Addon] ${message}`, data || '');
  }
  
  /**
   * NUEVO: Encontrar botones de checkout con fallbacks
   */
  function findCheckoutButtons() {
    // Intentar selector primario
    let buttons = document.querySelectorAll(CONFIG.checkoutButtonSelector);
    
    if (buttons.length > 0) {
      log(`✓ Botones encontrados con selector primario (${buttons.length})`);
      return buttons;
    }
    
    // Intentar selectores de respaldo
    for (let selector of CONFIG.checkoutButtonFallbacks) {
      buttons = document.querySelectorAll(selector);
      if (buttons.length > 0) {
        log(`⚠️ Botones encontrados con fallback: ${selector} (${buttons.length})`);
        return buttons;
      }
    }
    
    log('❌ No se encontraron botones de checkout');
    return document.querySelectorAll(CONFIG.checkoutButtonSelector); // Retornar vacío
  }
  
  /**
   * DESHABILITAR checkout (estado por defecto)
   */
  function disableCheckout(reason = 'Verificando carrito...') {
    const buttons = findCheckoutButtons();
    
    if (buttons.length === 0) {
      log('⚠️ No se encontraron botones protegidos');
      return;
    }
    
    buttons.forEach(button => {
      // Guardar el HTML original si no existe (primera vez)
      if (!button.dataset.originalHtml) {
        button.dataset.originalHtml = button.innerHTML;
        // Solo en la primera vez (inicialización), cambiar el texto
        button.textContent = 'Actualizando carrito...';
      }
      
      // Siempre deshabilitar
      button.disabled = true;
      button.style.opacity = '0.6';
      button.style.cursor = 'not-allowed';
      button.style.pointerEvents = 'none';
      button.title = reason;
    });
    
    checkoutEnabled = false;
    log(`🔒 Checkout deshabilitado: ${reason}`);
  }
  
  /**
   * HABILITAR checkout (solo cuando todo esté correcto)
   */
  function enableCheckout() {
    const buttons = findCheckoutButtons();
    
    if (buttons.length === 0) return;
    
    buttons.forEach(button => {
      // Habilitar botón
      button.disabled = false;
      button.style.opacity = '';
      button.style.cursor = '';
      button.style.pointerEvents = '';
      button.title = '';
      
      // Restaurar HTML original si existe
      if (button.dataset.originalHtml) {
        button.innerHTML = button.dataset.originalHtml;
      }
    });
    
    checkoutEnabled = true;
    log('🔓 Checkout habilitado - Carrito correcto');
    
    // Limpiar timeout de seguridad si existe
    if (safetyTimeoutId) {
      clearTimeout(safetyTimeoutId);
      safetyTimeoutId = null;
    }
  }
  
  function hasPavData() {
    return window._pav && Object.keys(window._pav).length > 0;
  }
  
  function extractPavIds() {
    const ids = new Set();
    if (hasPavData()) {
      Object.values(window._pav).forEach(variantIds => {
        if (Array.isArray(variantIds)) {
          variantIds.forEach(id => ids.add(Number(id)));
        }
      });
    }
    return ids;
  }
  
  async function initializePreorderData() {
    log('🔄 Inicializando datos de pre-order...');
    
    const cached = sessionStorage.getItem('_pov');
    let hasCachedData = false;
    
    if (cached) {
      try {
        const ids = JSON.parse(cached);
        if (Array.isArray(ids) && ids.length > 0) {
          ids.forEach(id => preorderVariants.add(Number(id)));
          hasCachedData = true;
          log(`✓ ${preorderVariants.size} variantes desde sessionStorage`);
        }
      } catch (e) {
        log('Error parseando caché', e);
      }
    }
    
    if (hasCachedData) {
      log('✓ Datos en caché disponibles, fusión rápida...');
      
      await new Promise((resolve) => {
        let attempts = 0;
        const quickCheck = () => {
          attempts++;
          
          if (hasPavData()) {
            const pavIds = extractPavIds();
            const sizeBefore = preorderVariants.size;
            pavIds.forEach(id => preorderVariants.add(id));
            
            if (preorderVariants.size > sizeBefore) {
              log(`✅ Fusionado: ${sizeBefore} + ${preorderVariants.size - sizeBefore} = ${preorderVariants.size}`);
            }
            
            sessionStorage.setItem('_pov', JSON.stringify([...preorderVariants]));
            resolve(true);
            
          } else if (attempts >= 2) {
            log('✓ Continuando con datos de caché (window._pav no necesario)');
            resolve(true);
            
          } else {
            setTimeout(quickCheck, 500);
          }
        };
        
        quickCheck();
      });
      
      log(`📋 Total variantes: ${[...preorderVariants].join(', ')}`);
      return true;
    }
    
    log('⏳ Sin caché, esperando window._pav...');
    
    return new Promise((resolve) => {
      const checkPav = () => {
        pavCheckAttempts++;
        
        if (hasPavData()) {
          const pavIds = extractPavIds();
          pavIds.forEach(id => preorderVariants.add(id));
          
          log(`✅ window._pav cargado: ${preorderVariants.size} variantes`);
          sessionStorage.setItem('_pov', JSON.stringify([...preorderVariants]));
          log(`📋 Total variantes: ${[...preorderVariants].join(', ')}`);
          resolve(true);
          
        } else if (pavCheckAttempts * 500 >= CONFIG.maxWaitForPav) {
          log(`⚠️ Timeout esperando window._pav sin caché`);
          resolve(false);
          
        } else {
          setTimeout(checkPav, 500);
        }
      };
      
      checkPav();
    });
  }
  
  function updatePreorderData() {
    const cached = sessionStorage.getItem('_pov');
    if (cached) {
      try {
        const ids = JSON.parse(cached);
        if (Array.isArray(ids)) {
          preorderVariants.clear();
          ids.forEach(id => preorderVariants.add(Number(id)));
        }
      } catch (e) {
        log('Error cargando caché', e);
      }
    }
    
    if (hasPavData()) {
      const sizeBefore = preorderVariants.size;
      const pavIds = extractPavIds();
      
      pavIds.forEach(id => preorderVariants.add(id));
      
      if (preorderVariants.size > sizeBefore) {
        const newIds = preorderVariants.size - sizeBefore;
        log(`📊 Fusión: ${sizeBefore} + ${newIds} = ${preorderVariants.size} variantes`);
        sessionStorage.setItem('_pov', JSON.stringify([...preorderVariants]));
      }
    }
    
    return preorderVariants.size > 0;
  }
  
  function isVariantInPreorder(variantId) {
    const numericId = Number(variantId);
    return preorderVariants.has(numericId);
  }
  
  async function getCart() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('[PreOrder Addon] Error obteniendo carrito:', error);
      return null;
    }
  }
  
  function getCartStateHash(cart) {
    if (!cart || !cart.items) return '';
    return cart.items
      .map(item => `${item.variant_id}:${item.quantity}`)
      .sort()
      .join('|');
  }
  
  function analyzeCart(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return {
        hasPreOrders: false,
        hasNormalProducts: false,
        preOrderCount: 0,
        normalCount: 0
      };
    }
    
    let preOrderCount = 0;
    let normalCount = 0;
    
    cart.items.forEach(item => {
      if (CONFIG.addonProductId && item.product_id === CONFIG.addonProductId) return;
      if (CONFIG.addonProductHandle && item.handle === CONFIG.addonProductHandle) return;
      
      if (isVariantInPreorder(item.variant_id)) {
        preOrderCount++;
      } else {
        normalCount++;
      }
    });
    
    return {
      hasPreOrders: preOrderCount > 0,
      hasNormalProducts: normalCount > 0,
      preOrderCount,
      normalCount
    };
  }
  
  function getAddonInCart(cart) {
    if (!cart || !cart.items) return null;
    
    const addonItem = cart.items.find(item => {
      if (CONFIG.addonProductId) return item.product_id === CONFIG.addonProductId;
      if (CONFIG.addonProductHandle) return item.handle === CONFIG.addonProductHandle;
      return false;
    });
    
    if (!addonItem) return null;
    
    return {
      variantId: addonItem.variant_id,
      key: addonItem.key,
      quantity: addonItem.quantity
    };
  }
  
  function getRequiredAddonVariant(cartAnalysis) {
    if (cartAnalysis.hasPreOrders && !cartAnalysis.hasNormalProducts) {
      return 'A';
    }
    
    if (cartAnalysis.hasPreOrders && cartAnalysis.hasNormalProducts) {
      return 'B';
    }
    
    return null;
  }
  
  async function getAddonVariantIds() {
    if (!CONFIG.useAutoVariants && CONFIG.addonVariantA_Id && CONFIG.addonVariantB_Id) {
      return {
        variantA: CONFIG.addonVariantA_Id,
        variantB: CONFIG.addonVariantB_Id
      };
    }
    
    try {
      const response = await fetch(`/products/${CONFIG.addonProductHandle}.js`);
      if (!response.ok) return null;
      
      const product = await response.json();
      if (!product.variants || product.variants.length < 2) return null;
      
      return {
        variantA: product.variants[0].id,
        variantB: product.variants[1].id
      };
    } catch (error) {
      console.error('[PreOrder Addon] Error obteniendo variantes:', error);
      return null;
    }
  }
  
  async function addAddonFee(requiredVariant) {
    try {
      log(`➕ Agregando variante ${requiredVariant}...`);
      
      const variantIds = await getAddonVariantIds();
      if (!variantIds) return false;
      
      const variantId = requiredVariant === 'A' ? variantIds.variantA : variantIds.variantB;
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      
      if (response.ok) {
        log(`✅ Fee agregado (Var ${requiredVariant})`);
        return true;
      }
      return false;
    } catch (error) {
      console.error('[PreOrder Addon] Error en addAddonFee:', error);
      return false;
    }
  }
  
  async function removeAddonFee(addonInCart) {
    try {
      if (!addonInCart) return false;
      
      log(`➖ Removiendo fee...`);
      
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: addonInCart.key, quantity: 0 })
      });
      
      if (response.ok) {
        log('✅ Fee removido');
        if (window.location.pathname === '/cart') {
          setTimeout(() => window.location.reload(), 500);
        }
        return true;
      }
      return false;
    } catch (error) {
      console.error('[PreOrder Addon] Error en removeAddonFee:', error);
      return false;
    }
  }
  
  async function swapAddonVariant(currentAddon, requiredVariant) {
    try {
      log(`🔄 Swap: Variante actual → ${requiredVariant}`);
      
      await removeAddonFee(currentAddon);
      await new Promise(resolve => setTimeout(resolve, 300));
      
      const added = await addAddonFee(requiredVariant);
      
      if (added) {
        log(`✅ Swap completado: Variante ${requiredVariant}`);
      }
      
      return added;
    } catch (error) {
      console.error('[PreOrder Addon] Error en swapAddonVariant:', error);
      return false;
    }
  }
  
  /**
   * NUEVA FUNCIÓN: Verificar si el carrito está correcto
   * Retorna true si el fee es correcto, false si necesita cambios
   */
  async function isCartCorrect() {
    const cart = await getCart();
    if (!cart) return false;
    
    const cartAnalysis = analyzeCart(cart);
    const addonInCart = getAddonInCart(cart);
    const requiredVariant = getRequiredAddonVariant(cartAnalysis);
    
    // Caso 1: Necesita fee pero no lo tiene
    if (requiredVariant && !addonInCart) {
      return false;
    }
    
    // Caso 2: No necesita fee pero lo tiene
    if (!requiredVariant && addonInCart) {
      return false;
    }
    
    // Caso 3: Necesita fee y lo tiene, verificar variante
    if (requiredVariant && addonInCart) {
      const variantIds = await getAddonVariantIds();
      if (variantIds) {
        const correctVariantId = requiredVariant === 'A' ? variantIds.variantA : variantIds.variantB;
        if (addonInCart.variantId !== correctVariantId) {
          return false;
        }
      }
    }
    
    // Todo correcto
    return true;
  }
  
  async function updateCartAddons() {
    if (isProcessing) return;
    
    isProcessing = true;
    
    try {
      const hasData = updatePreorderData();
      
      if (!hasData) {
        isProcessing = false;
        return;
      }
      
      const cart = await getCart();
      if (!cart) {
        isProcessing = false;
        return;
      }
      
      const newStateHash = getCartStateHash(cart);
      const cartChanged = lastCartState !== newStateHash;
      
      if (cartChanged) {
        // NUEVO: Deshabilitar checkout al detectar cambio
        disableCheckout('Actualizando carrito...');
        
        lastCartState = newStateHash;
        
        const cartAnalysis = analyzeCart(cart);
        const addonInCart = getAddonInCart(cart);
        const requiredVariant = getRequiredAddonVariant(cartAnalysis);
        
        let changesMade = false;
        
        // CASO 1: Agregar fee
        if (requiredVariant && !addonInCart) {
          changesMade = true;
          const added = await addAddonFee(requiredVariant);
          if (added) await refreshCartUI();
        }
        // CASO 2: Remover fee
        else if (!requiredVariant && addonInCart) {
          changesMade = true;
          const removed = await removeAddonFee(addonInCart);
          if (removed) await refreshCartUI();
        }
        // CASO 3: Cambiar variante (SWAP)
        else if (requiredVariant && addonInCart) {
          const variantIds = await getAddonVariantIds();
          if (variantIds) {
            const correctVariantId = requiredVariant === 'A' ? variantIds.variantA : variantIds.variantB;
            
            if (addonInCart.variantId !== correctVariantId) {
              changesMade = true;
              const swapped = await swapAddonVariant(addonInCart, requiredVariant);
              if (swapped) await refreshCartUI();
            }
          }
        }
        
        // NUEVO: Verificar que todo esté correcto antes de habilitar
        if (changesMade) {
          // Esperar un momento para que los cambios se apliquen
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // Verificar si el carrito quedó correcto
          const isCorrect = await isCartCorrect();
          
          if (isCorrect) {
            enableCheckout();
          } else {
            disableCheckout('Actualizando carrito...');
            log('⚠️ Carrito no se corrigió en primer intento, reintentando...');
          }
        } else {
          // No hubo cambios, verificar si ya está correcto
          const isCorrect = await isCartCorrect();
          
          if (isCorrect) {
            enableCheckout();
          } else {
            disableCheckout('Verificando carrito...');
          }
        }
      }
      
    } catch (error) {
      console.error('[PreOrder Addon] Error:', error);
      disableCheckout('Actualizando carrito...');
    } finally {
      isProcessing = false;
    }
  }
  
  async function refreshCartUI() {
    log('🔄 Refrescando UI del carrito...');
    
    await new Promise(resolve => setTimeout(resolve, 300));
    
    if (window.theme?.cart?.getCart) {
      window.theme.cart.getCart();
    }
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents();
    }
    
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      cartNotification.renderContents();
    }
    
    document.dispatchEvent(new CustomEvent('cart:updated'));
    
    if (window.location.pathname === '/cart') {
      log('📍 En página de carrito, programando recarga de seguridad...');
      setTimeout(() => {
        window.location.reload();
      }, 600);
    }
    
    setTimeout(() => {
      lastCartState = null;
    }, 1000);
  }
  
  function startCartMonitoring() {
    if (checkIntervalId) {
      clearInterval(checkIntervalId);
    }
    
    checkIntervalId = setInterval(() => {
      updateCartAddons();
    }, CONFIG.checkInterval);
  }
  
  function interceptFetch() {
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
      const url = args[0];
      
      if (typeof url === 'string' && 
          (url.includes('/cart/add.js') || 
           url.includes('/cart/change.js') || 
           url.includes('/cart/update.js') ||
           url.includes('/cart/clear.js'))) {
        
        return originalFetch.apply(this, args).then(response => {
          setTimeout(() => {
            lastCartState = null;
            updateCartAddons();
          }, 100);
          
          return response;
        });
      }
      
      return originalFetch.apply(this, args);
    };
  }
  
  async function init() {
    log('╔═══════════════════════════════════════╗');
    log('║  Pre-Order Addon v6.4                ║');
    log('╚═══════════════════════════════════════╝');
    
    if (!CONFIG.addonProductId && !CONFIG.addonProductHandle) {
      console.error('[PreOrder Addon] ERROR: Config addon');
      return;
    }
    
    // NUEVO: Asegurar que el botón esté deshabilitado al inicio
    disableCheckout('Inicializando...');
    
    // NUEVO: Timeout de seguridad - Habilitar después de X segundos si no se ha habilitado
    safetyTimeoutId = setTimeout(() => {
      if (!checkoutEnabled) {
        log('⚠️ SAFETY TIMEOUT: Habilitando checkout forzadamente después de ' + (CONFIG.safetyTimeout/1000) + 's');
        enableCheckout();
      }
    }, CONFIG.safetyTimeout);
    
    await initializePreorderData();
    
    interceptFetch();
    
    // Primera verificación completa
    setTimeout(async () => {
      await updateCartAddons();
    }, 1000);
    
    startCartMonitoring();
    
    log('✓ Listo');
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  window.addEventListener('beforeunload', () => {
    if (checkIntervalId) {
      clearInterval(checkIntervalId);
    }
    if (safetyTimeoutId) {
      clearTimeout(safetyTimeoutId);
    }
  });
  
})();